module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('div', [_c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main')], 1), _vm._v(" "), _c('footer-bar'), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e6e8d8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 117
// module chunks = 11